import { track } from '../../../services/analytics/analytics'

export function trackPageViewed(payload: { departmentId?: string; departmentName?: string }) {
  void track('TEAM_ENERGY_PAGE_VIEWED', payload)
}

export function trackSwitchDepartment(payload: { fromDepartmentId?: string; toDepartmentId: string }) {
  void track('TEAM_ENERGY_DEPARTMENT_SWITCHED', payload)
}

export function trackActionsExpanded() {
  void track('TEAM_ENERGY_ACTIONS_EXPANDED', {})
}

export function trackMemberClicked(payload: { userId: string; status: string }) {
  void track('TEAM_ENERGY_MEMBER_CLICKED', payload)
}

export function trackSuggestionViewed(payload: { userId: string; suggestionCount: number; contextType?: string }) {
  void track('TEAM_ENERGY_SUGGESTION_VIEWED', payload)
}

export function trackPageChanged(payload: { page: number; pageSize: number }) {
  void track('TEAM_ENERGY_MEMBERS_TABLE_PAGE_CHANGED', payload)
}

export function trackSearchUsed(payload: { queryLength: number }) {
  void track('TEAM_ENERGY_SEARCH_USED', payload)
}
